module.exports = __webpack_public_path__ + "img/2-2.679bdc18.jpg";